import OspreyApiHelper from './helper'

export default class OspreyAffiliations {

    static get(path, params) {
        return OspreyApiHelper.genericGet(path, params)
    }
}



// WEBPACK FOOTER //
// src/services/osprey-api/api-affiliations.js